import { defineComponent as r, createBlock as l, openBlock as a, unref as c, mergeProps as p, withCtx as i, createElementVNode as n } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconCheckInCircle",
  __name: "IconCheckInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (m, e) => (a(), l(c(d), p(t, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        n("path", { d: "M17.03 9.53a.75.75 0 0 0-1.06-1.06l-5.47 5.47-2.47-2.47a.75.75 0 0 0-1.06 1.06l2.646 2.647a1.25 1.25 0 0 0 1.768 0L17.03 9.53" }, null, -1),
        n("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
